/** Foundation · Copy — ambito della copia: mese intero, una settimana, giornate selezionate. */
import React from "react";
import { weeksOf } from "./copyPlanner";

const WD = ["L", "M", "M", "G", "V", "S", "D"];
const TABS = [{ type: "month", label: "Mese intero" }, { type: "week", label: "Settimana" }, { type: "days", label: "Giornate" }];

export function CopyScopePicker({ dates, value, onChange }) {
  const weeks = weeksOf(dates);
  const selected = value.type === "days" ? value.dates || [] : [];
  const toggle = (d) => onChange({ type: "days", dates: selected.includes(d) ? selected.filter((x) => x !== d) : [...selected, d] });
  return (
    <div className="space-y-2" data-testid="copy-from-scope">
      <div className="text-[10px] font-semibold uppercase tracking-wider text-suite-neutral-500">Applica a</div>
      <div className="inline-flex rounded-md border border-suite-neutral-200 p-0.5">
        {TABS.map((t) => (
          <button key={t.type} type="button" onClick={() => onChange(t.type === "week" ? { type: "week", week: 0 } : t.type === "days" ? { type: "days", dates: selected } : { type: "month" })}
            className={`rounded px-2.5 py-1 text-xs ${value.type === t.type ? "bg-suite-primary text-white" : "text-suite-neutral-600 hover:bg-suite-neutral-100"}`}
            data-testid={`copy-from-scope-${t.type}`}>{t.label}</button>
        ))}
      </div>
      {value.type === "week" && (
        <select value={value.week} onChange={(e) => onChange({ type: "week", week: Number(e.target.value) })}
          className="h-8 w-full rounded-md border border-input bg-white px-2 text-xs" data-testid="copy-from-scope-week-select">
          {weeks.map((w) => <option key={w.index} value={w.index}>{w.label}</option>)}
        </select>
      )}
      {value.type === "days" && (
        <div className="grid grid-cols-7 gap-1" data-testid="copy-from-scope-days">
          {WD.map((w, i) => <div key={i} className="text-center text-[9px] text-suite-neutral-400">{w}</div>)}
          {Array.from({ length: (new Date(`${dates[0]}T00:00:00`).getDay() + 6) % 7 }).map((_, i) => <div key={`p${i}`} />)}
          {dates.map((d) => (
            <button key={d} type="button" onClick={() => toggle(d)} data-testid={`copy-from-day-${d}`}
              className={`h-7 rounded text-[11px] font-mono ${selected.includes(d) ? "bg-suite-primary text-white" : "bg-suite-neutral-50 text-suite-neutral-700 hover:bg-suite-neutral-100"}`}>
              {Number(d.slice(8))}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default CopyScopePicker;
